// extracted by mini-css-extract-plugin
export default {"security":"Security_security__B-AVC","button":"Security_button__gmcG6","form":"Security_form__BB7Ja"};